import { useState } from "react";
import { useScrollAnimation, useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";

const testimonials = [
  {
    name: "Ramesh Naidu",
    location: "Sarjapur Road, Bengaluru",
    review: "Urban Infra made our dream of owning a plot on Sarjapur Road a reality. The process was transparent, documentation was clean, and the team was always available. Highly recommended!",
    rating: 5,
    project: "Sai Meadows Phase II",
    avatar: "RN",
  },
  {
    name: "Kavitha & Suresh Reddy",
    location: "Bengaluru",
    review: "We purchased a plot in Urban Palms and the experience was outstanding. The team was professional, responsive, and genuinely helpful. The location on Sarjapur Road is perfect and the infrastructure is top-notch.",
    rating: 5,
    project: "Urban Palms",
    avatar: "KS",
  },
  {
    name: "Pradeep Sharma",
    location: "Bengaluru",
    review: "After years of searching for gated community plots on Sarjapur Road, we found Urban Infra. They delivered exactly as promised — clear title, wide roads, and all amenities. Our investment has already appreciated significantly!",
    rating: 5,
    project: "Anaaya Bliss",
    avatar: "PS",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { setRef, visibleItems } = useScrollAnimationMultiple(testimonials.length);

  return (
    <section id="testimonials" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headRef as (el: HTMLDivElement | null) => void}
          className={`flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12 reveal ${headVisible ? "visible" : ""}`}
        >
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-[#EAF5E1] px-3 py-1.5 rounded-full mb-3">
              Client Stories
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]" style={{ fontFamily: "'Playfair Display', serif" }}>
              What Our Clients Say
            </h2>
          </div>
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button key={i} onClick={() => setActive(i)} className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${active === i ? "w-8 bg-[#7FBF3F]" : "w-2 bg-gray-300"}`} />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              ref={setRef(i) as (el: HTMLDivElement | null) => void}
              onClick={() => setActive(i)}
              className={`card-hover bg-white rounded-2xl p-7 border cursor-pointer reveal reveal-delay-${i + 1} ${visibleItems[i] ? "visible" : ""} ${active === i ? "border-[#7FBF3F]/30 bg-[#EAF5E1]/40" : "border-gray-100 hover:border-[#7FBF3F]/20"}`}
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-[#F36F21] text-sm"></i>
                ))}
              </div>
              <i className="ri-double-quotes-l text-3xl text-[#EAF5E1] block mb-2"></i>
              <p className="text-gray-600 text-sm leading-relaxed mb-6" style={{ fontFamily: "'Poppins', sans-serif" }}>{t.review}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1B2A4A] text-white text-xs font-bold rounded-full flex-shrink-0">
                  {t.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#1B2A4A]">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.location}</div>
                </div>
                <div className="ml-auto">
                  <span className="text-xs text-[#7FBF3F] bg-[#EAF5E1] px-2 py-1 rounded-full font-medium whitespace-nowrap">{t.project}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
